import { NODE_UNCHECK_USER } from '@/constants/login'
import { HTTPResponse } from '@/types/common'
import { createModel } from 'hox'
import { useState } from 'react'

import useTeacherInfo from './teacherInfo'
import useMeasureConnectionSpeed from './connectionSpeed'

export const requestInterceptor = async function requestInterceptor<T>(request: () => Promise<T>): Promise<HTTPResponse<T | null>> {
  try {
    // 统一拦截pdf打印
    if (navigator.userAgent.includes(NODE_UNCHECK_USER)) {
      return {
        code: '0',
        message: 'not-request-because-pdf-print',
        result: null,
      }
    }
    const result = await request()
    return {
      code: '200',
      message: 'success',
      result,
    }
  } catch (e: any) {
    console.warn(e)
    return {
      code: '0',
      message: e,
      result: null,
    }
  }
}

/**
 * 1. 接口相关的数据，不直接对外暴露 setState 之类的方法，只暴露对应只读的值和统一的更新方法，更新方法由 requestInterceptor 包裹后再对外暴露
 * 2. 不需要接口交互的数据可以直接暴露值和 setState，但是仍然统一放到这个文件来暴露
 */
function useGlobalHoxFn() {
  const teacherInfo = useTeacherInfo()
  const connectionSpeed = useMeasureConnectionSpeed()
  const [globalHoxOk, setGlobalHoxOk] = useState(false)

  // 更新所有的全局数据
  const updateGlobalHox = async () => {
    const res = await requestInterceptor(async () => {
      const result = await Promise.all([
        teacherInfo.updateTotalTeacherInfo(),
      ])
      return {
        teacherInfo: result[0],
      }
    })
    setGlobalHoxOk(true)
    // 返回请求结果，以便可以在调用更新方法的时候实时拿到最新数据
    return res
  }
  // 导出的时候，包裹上命名空间
  return {
    updateGlobalHox,
    globalHoxOk,
    teacherInfo: {
      ...teacherInfo,
    },
    ...connectionSpeed,
  }
}

export const useGlobalHox = createModel(useGlobalHoxFn)
